import { atomWithStorage } from "jotai/utils";
import { atom } from "jotai";
import { Artist } from "../models/artist";
import { StoreKey } from "../models/cacheKey";

export const mainArtistAtom = atomWithStorage<number>(StoreKey.mainArtist, -1);

export const currentArtistAtom = atom<Artist | undefined>(undefined);
